/* revermieux — panier : minuteur « articles réservés » */
(() => {
  if (window.__rmTimer) return;
  window.__rmTimer = true;
  const KEY = 'rmCartTimer';
  let end = 0;
  try { end = Number(sessionStorage.getItem(KEY)) || 0; } catch (e) {}
  if (end && end < Date.now()) end = 0;
  const pad = (n) => String(n).padStart(2, '0');
  const tick = () => {
    const boxes = document.querySelectorAll('[data-rm-timer]');
    if (!boxes.length) return;
    if (!end) {
      end = Date.now() + (Number(boxes[0].dataset.rmTimer) || 10) * 60000;
      try { sessionStorage.setItem(KEY, String(end)); } catch (e) {}
    }
    const left = Math.max(0, Math.round((end - Date.now()) / 1000));
    const txt = pad(Math.floor(left / 60)) + ':' + pad(left % 60);
    boxes.forEach((box) => {
      const out = box.querySelector('[data-rm-timer-v]');
      if (!out) return;
      // On modifie le nœud texte (et non textContent) pour ne pas réveiller l'observateur du panier ci-dessous.
      const node = out.firstChild;
      if (node && node.nodeType === 3) {
        if (node.nodeValue !== txt) node.nodeValue = txt;
      } else {
        out.textContent = txt;
      }
    });
  };
  tick();
  setInterval(tick, 1000);
})();

/* revermieux — panier : produits proposés (interrupteur + quantité) et taies offertes synchronisées.
   Shopify peut couper un même article en plusieurs lignes (remise sur une partie) :
   on met donc à jour les lignes par leur clé, pas seulement par variante. */
(() => {
  if (window.__rmUpsell) return;
  window.__rmUpsell = true;

  /*
    Taies offertes : chaque article donne droit à N taies, de la couleur correspondante.
    Le panier est corrigé automatiquement : on ne peut ni en ajouter plus, ni en garder sans l'article.
  */
  const GIFTS = {
    'easysleep-couette-2-en-1': { gift: 'lot-2-taies-oreiller-classiques', n: 2, map: {} },
    draps: {
      gift: 'lot-2-taies-oreiller-classiques',
      n: 2,
      map: {
        'Gris perle': 'Gris pierre de lune',
        'Bleu ciel': 'Bleu côtier',
        Lavande: 'Violet crépuscule',
        'Vert menthe': 'Vert menthe doux',
        'Vert tilleul': 'Vert menthe doux',
        'Jaune vanille': 'Beige crème',
        'Rose poudré': 'Beige crème',
        Moka: 'Beige crème',
        Prune: 'Violet crépuscule',
        'Bleu nuit': 'Bleu côtier',
        'Noir charbon': 'Noir minuit',
      },
    },
    'oreiller-nuage': {
      gift: 'taie-doreiller-assortie',
      n: 1,
      map: { Gris: 'Gris pierre de lune', Azure: 'Bleu clair', Navy: 'Bleu côtier', Blanc: 'Blanc' },
    },
  };
  const giftHandles = new Set(Object.values(GIFTS).map((g) => g.gift));
  const productCache = {};
  const loadProduct = (handle) => {
    if (!productCache[handle]) {
      productCache[handle] = fetch(`/products/${handle}.js`, { headers: { Accept: 'application/json' } })
        .then((r) => (r.ok ? r.json() : null))
        .catch(() => null);
    }
    return productCache[handle];
  };
  const colorOf = (item) => {
    const opt = (item.options_with_values || []).find((o) => /couleur|color|coloris/i.test(o.name));
    return opt ? opt.value : null;
  };

  /** Taies voulues pour ce panier : { variantId: quantité }. */
  const desiredGifts = async (cart) => {
    const want = {};
    for (const item of cart.items) {
      const rule = GIFTS[item.handle];
      if (!rule) continue;
      const gift = await loadProduct(rule.gift);
      if (!gift) continue;
      const own = colorOf(item);
      const color = (own && rule.map[own]) || own;
      const variant =
        (color && gift.variants.find((v) => v.available && v.options.includes(color))) ||
        gift.variants.find((v) => v.available);
      if (variant) want[variant.id] = (want[variant.id] || 0) + rule.n * item.quantity;
    }
    return want;
  };

  /** Écart entre les taies du panier réel et celles voulues : mise à jour par clé de ligne (ou par variante si absente). */
  const giftDiff = (cart, want) => {
    const lines = {};
    cart.items.forEach((item) => {
      if (giftHandles.has(item.handle)) (lines[item.variant_id] = lines[item.variant_id] || []).push(item);
    });
    const updates = {};
    new Set([...Object.keys(want), ...Object.keys(lines)]).forEach((id) => {
      const w = want[id] || 0;
      const list = lines[id] || [];
      const have = list.reduce((sum, l) => sum + l.quantity, 0);
      if (have === w) return;
      if (!list.length) {
        if (w > 0) updates[id] = w;
        return;
      }
      list.forEach((l, k) => (updates[l.key] = k === 0 ? w : 0));
    });
    return updates;
  };
  const giftUpdates = async (cart) => giftDiff(cart, await desiredGifts(cart));

  const getCart = () => fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());

  /** Envoie une mise à jour et rafraîchit le tiroir du panier (même mécanisme que le thème). */
  const send = async (source, updates) => {
    const host = document.querySelector('cart-items-component[data-section-id]');
    const sectionId = host && host.dataset.sectionId;
    let events = null;
    try {
      events = await import('@shopify/events');
    } catch (e) {
      events = null;
    }
    let deferred = null;
    if (events && events.CartLinesUpdateEvent) {
      deferred = events.CartLinesUpdateEvent.createPromise();
      deferred.promise.catch(() => {});
      (source || document.body).dispatchEvent(
        new events.CartLinesUpdateEvent({
          action: 'update',
          context: 'cart',
          lines: Object.entries(updates).map(([id, quantity]) => ({ merchandiseId: String(id), quantity })),
          promise: deferred.promise,
        })
      );
    }
    try {
      const res = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(sectionId ? { updates, sections: sectionId } : { updates }),
      });
      const cart = await res.json();
      if (deferred) {
        deferred.resolve({
          cart: events.CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
          detail: { items: cart.items, source: 'rm-cart', sections: cart.sections, didError: Boolean(cart.status) },
        });
      }
      return cart;
    } catch (error) {
      if (deferred) deferred.reject(error);
      return null;
    }
  };

  /** Vérifie les taies offertes et corrige le panier si besoin. */
  let syncing = false;
  let again = false;
  const syncGifts = async () => {
    if (syncing) {
      again = true;
      return;
    }
    syncing = true;
    try {
      const cart = await getCart();
      const updates = await giftUpdates(cart);
      if (Object.keys(updates).length) await send(null, updates);
    } catch (e) {
      /* rien : on réessaiera au prochain changement */
    }
    syncing = false;
    if (again) {
      again = false;
      syncGifts();
    }
  };
  let timer = 0;
  const scheduleSync = () => {
    clearTimeout(timer);
    timer = setTimeout(syncGifts, 500);
  };

  // Le tiroir est re-rendu après chaque changement du panier : on vérifie alors les taies.
  const watch = () => {
    document.querySelectorAll('cart-items-component').forEach((node) => {
      if (node.__rmWatched) return;
      node.__rmWatched = true;
      new MutationObserver(scheduleSync).observe(node, { childList: true, subtree: true });
    });
  };
  watch();
  new MutationObserver(watch).observe(document.documentElement, { childList: true, subtree: true });
  scheduleSync();

  /* Produits proposés dans le panier */
  const variantFor = (item) => {
    const list = JSON.parse(item.querySelector('[data-rm-up-v]').textContent);
    const picked = Array.from(item.querySelectorAll('[data-rm-up-opt]')).map((s) => s.value);
    return list.find((v) => v.o.every((o, i) => picked[i] === undefined || picked[i] === o)) || list[0];
  };
  const qtyOf = (item) => {
    const out = item.querySelector('[data-rm-up-n]');
    return Math.max(1, Number(out && out.textContent) || 1);
  };
  const show = (item, v) => {
    item.querySelector('[data-rm-up-p]').textContent = v.p;
    const c = item.querySelector('[data-rm-up-c]');
    c.textContent = v.c;
    c.hidden = !v.c;
    const img = item.querySelector('[data-rm-up-img]');
    if (img && v.i) img.src = v.i;
  };
  const busy = (item, on) => {
    item.classList.toggle('is-busy', on);
    item.querySelectorAll('input,select,button').forEach((el) => (el.disabled = on));
  };

  /**
   * Met l'article proposé à « qty » exemplaires de la variante v (v = null ou qty = 0 : le retire),
   * avec ses taies offertes, en une seule mise à jour.
   */
  const apply = async (item, v, qty) => {
    busy(item, true);
    try {
      const cart = await getCart();
      const handle = item.dataset.handle;
      const updates = {};
      let placed = false;
      cart.items
        .filter((l) => l.handle === handle)
        .forEach((l) => {
          if (v && qty > 0 && !placed && String(l.variant_id) === String(v.id)) {
            updates[l.key] = qty;
            placed = true;
          } else {
            updates[l.key] = 0;
          }
        });
      if (v && qty > 0 && !placed) updates[v.id] = qty;

      // Panier tel qu'il sera après la mise à jour, pour calculer les taies.
      const next = { items: cart.items.filter((l) => l.handle !== handle).map((l) => ({ ...l })) };
      if (v && qty > 0) {
        const product = await loadProduct(handle);
        const pv = product && product.variants.find((x) => String(x.id) === String(v.id));
        if (pv) next.items.push({ handle, variant_id: pv.id, quantity: qty, options_with_values: product.options.map((o, k) => ({ name: o.name, value: pv.options[k] })) });
      }
      Object.assign(updates, giftDiff(cart, await desiredGifts(next)));
      const done = await send(item, updates);
      if (!done) busy(item, false);
    } catch (e) {
      busy(item, false);
    }
  };

  document.addEventListener('change', (event) => {
    const item = event.target.closest && event.target.closest('[data-rm-up-item]');
    if (!item) return;
    const box = item.querySelector('[data-rm-up-on]');
    const v = variantFor(item);
    show(item, v);
    if (event.target === box) {
      if (box.checked && !v.a) {
        box.checked = false;
        return;
      }
      apply(item, box.checked ? v : null, box.checked ? qtyOf(item) : 0);
      return;
    }
    if (box.checked && String(v.id) !== item.dataset.cur && v.a) apply(item, v, qtyOf(item));
  });

  // Boutons − / + : changent la quantité ; si l'article est déjà dans le panier, la ligne est mise à jour.
  document.addEventListener('click', (event) => {
    const btn = event.target.closest && event.target.closest('[data-rm-up-dec],[data-rm-up-inc]');
    if (!btn) return;
    const item = btn.closest('[data-rm-up-item]');
    if (!item || item.classList.contains('is-busy')) return;
    event.preventDefault();
    const max = Number(item.dataset.max) || 10;
    const before = qtyOf(item);
    const n = btn.hasAttribute('data-rm-up-inc') ? Math.min(max, before + 1) : Math.max(1, before - 1);
    if (n === before) return;
    item.querySelector('[data-rm-up-n]').textContent = String(n);
    item.querySelector('[data-rm-up-dec]').disabled = n <= 1;
    item.querySelector('[data-rm-up-inc]').disabled = n >= max;
    const box = item.querySelector('[data-rm-up-on]');
    if (!box.checked) return;
    const v = variantFor(item);
    if (v.a) apply(item, v, n);
  });
})();